export default __webpack_public_path__ + "static/media/video-background.d1a52a05.png";